import { forwardRef, useImperativeHandle, useState, useRef } from 'react'
import useSlides from './hooks/useSlides';
import Navigation from './components/Navigation';
import Slides from './components/Slides';
import ProgressBar from './components/ProgressBar';

const Game = forwardRef(function Game({ onAnswer }, ref) {
  const slides = useSlides();

  const [current, setCurrent] = useState(0);
  const [showFinish, setShowFinish] = useState(slides.length === 1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [direction, setDirection] = useState(1);
  const [initialization, setInitialization] = useState(false);

  const slidesRef = useRef(null);
  const navigationRef = useRef(null);

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      await slidesRef.current.animateEntry();
      await navigationRef.current.animateEntry();
      setInitialization(true);
    },
  }));

  const handleChangeCurrent = (newCurrent) => {
    if (newCurrent === slides.length - 1) {
      setShowFinish(true);
    }
    
    setCurrent(newCurrent);
  }

  const navigate = (direction) => {
    const nextPosition = current + direction;

    if (nextPosition < 0 || nextPosition >= slides.length) {
      return;
    }

    setDirection(direction);
    handleChangeCurrent(nextPosition);
  };

  const handleFinish = () => {
    setIsCompleted(true);
    onAnswer(true);
  }

  return (
      <>
      {!isCompleted && (
        <ProgressBar
          value={current + 1}
          total={initialization ? slides.length : 1_000_000}
        />
      )}

        <Slides 
          ref={slidesRef}
          current={current}
          direction={direction}
          onNavigate={navigate}
          onChangeCurrent={handleChangeCurrent}
          freeze={isCompleted}
        />

        <Navigation
            ref={navigationRef}
            freeze={isCompleted}
            onNext={() => navigate(1)}
            onFinish={handleFinish}
            onPrev={() => navigate(-1)}
            showFinish={showFinish}
            disabledNext={current === slides.length - 1}
            disabledPrev={current === 0}
        />
      </>
  )
})

export default Game